/**
 * Created by andrey on 19.12.19.
 */

const NoPayments = function () {
    Payments.call(this, connector.NONE);
};

NoPayments.prototype = Object.create(Payments.prototype);
NoPayments.prototype.constructor = NoPayments;

NoPayments.prototype._connect = function (callback) {
    callback(connector.STATUS_DISABLED);
};
